import { useAccount } from 'modules/account/hooks/useAccount';
import { useUser } from 'modules/user/hooks/useUser';
import { useWalletAddress } from 'modules/wallet/hooks/useWalletAddress';

// todo: MRPC-6788 remove this hook
export const useShouldDepositForAnotherAccount = () => {
  const { address: authAddress } = useUser();
  const { group: groupAddress } = useAccount();
  const { walletAddress } = useWalletAddress();

  const shouldDepositForAnotherAccount =
    Boolean(groupAddress) || authAddress !== walletAddress;

  return { shouldDepositForAnotherAccount };
};
